export default __webpack_public_path__ + "static/media/indeterminate_check_box.c949b588.svg";